// extracted by mini-css-extract-plugin
export var createdDate = "_l2-1";
export var divider = "_l2-2";
export var headerDivider = "_l2-3";
export var messagesCard = "_l2-0";
export var messagesContainer = "_l2-7";
export var messagesContainerWrapper = "_l2-4";
export var pointerCapturingButtonBoxes = "_l2-a";
export var showLeftPanelButton = "_l2-9";
export var showMoreButton = "_l2-c";
export var showMoreButtonContainer = "_l2-b";
export var summaryTitle = "_l2-6";
export var systemMessageCardWrapper = "_l2-d";
export var topButtons = "_l2-8";
export var withPadding = "_l2-5";